import { Modal } from 'antd';
import React from 'react';
import service from '../services'
import fetch from '../services/fetch';
import utils from '../utils';
import * as dd from 'dingtalk-jsapi'; // 此方式为整体加载，也可按需进行加载

export default class DDlogin extends React.Component {

    constructor(props) {
        super(props)
    }

    async componentDidMount() {

        let data = await service.account.website();

        sessionStorage.setItem('website', JSON.stringify(data));
        document.title = data.systemName;
        this.setState(Object.assign({}, this.state, data));

        dd.ready(function () {
            // dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
            dd.runtime.permission.requestAuthCode({
                corpId: ddCorpId,
                onSuccess: function (result) {
                    const url = window.location.hash;
                    // let ssoUrl = 'sso/login';
                    let index = url.indexOf('?');
                    let pageId = 0
                    if (index > -1) {
                        ddlogin = ddlogin + url.substr(index);
                        pageId = url.substr(url.indexOf('pageId=') + 7);
                    }
                    window.open(`${fetch.base}/${ddlogin}?code=${result.code}&ddtab=true`, '_self')
                },
                onFail: function (err) { }

            });
        });

    }

    transform(response) {
        const data = response.payload.data;

        return {
            success: true,
            code: response.code,
            message: response.message,
            payload: {
                account: {
                    id: data.employeeId,
                    loginName: data.loginName,
                    realName: data.realName,
                    orgName: data.orgXzName,
                    orgId: data.orgXzId,
                    schoolName: data.schoolName,
                    termName: data.termName,
                    yearName: data.yearName,
                    termId: data.termId,
                    yearId: data.yearId,
                    dudao: data.dudao,
                    userType: data.userType,
                    systemName: data.systemName
                },
                rules: data.roleModuleList.map((rule) => {
                    if ((rule.url || "").indexOf('/datav/index/') !== -1) {
                        var link = rule.url.split('/datav/index/')[1];
                        if (link) {
                            rule.url = "/datav/index/" + escape(link);
                        }
                    }
                    return {
                        id: rule.id,
                        name: rule.name,
                        pid: rule.pid,
                        url: rule.url,
                        depth: rule.level,
                        icon: rule.icon,
                        label: rule.label,
                        orderNum: rule.orderNum
                    }
                }),
                roleIds: data.roleIds,
            }
        };
    }

    saveSession(data) {
        var result = utils.tree(data.payload.rules);
        const operation = {};
        window.sessionStorage.setItem('session', JSON.stringify({
            account: data.payload.account,
            rules: result[0].children,
            roleIds: data.payload.roleIds,
            operation: operation
        }));

        return data.payload;
    }

    render() {
        return (
            <div>
                登陆中。。。
            </div>
        );
    }
}